import { findUrls } from '@/utils/helpers';
import axios from 'axios';
import { extend } from 'vee-validate';

type ReachableLinksValidationParams = {
    _value_?: string;
};

const ENDPOINT = '/press_releases/validate_links';

async function validateLinks(links: string[]) {
    return axios
        .post(ENDPOINT, { content: links })
        .then(({ data }) => {
            return data?.data?.success || false;
        })
        .catch(() => false);
}

extend('reachable_link', {
    validate(value: string) {
        if (!value) {
            return true;
        }

        const links = findUrls(value);

        if (links.length) {
            return validateLinks(links);
        } else {
            return true;
        }
    },

    message: (fieldName, placeholders) => {
        const { _value_ } = placeholders as ReachableLinksValidationParams;

        if (_value_) {
            const links = findUrls(_value_);

            if (links.length === 1) {
                return 'This link could not be reached. Please ensure that link provided is accessible.';
            }
        }

        return `Some of the ${fieldName} links provided could not be reached. Please ensure that all links provided are accessible.'`;
    }
});
